import { handleActions } from 'redux-actions';
import * as R from 'ramda';

import {
  FETCH_CHAT_STATS,
  FETCH_CHATS_STATS,
  CHATS_FILTER_SET
} from '../../constants/Constants';

const initialState = { items: [], filter: null, currentChatStats: {}, pagination: { page: 0, size: 50 } };

const COLLATOR = new Intl.Collator('cs');
const nameComparator = (a, b) => COLLATOR.compare(a.name, b.name);

export default handleActions(
  {
    [FETCH_CHATS_STATS.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      items: R.sortWith([nameComparator])(items)
    }),
    [FETCH_CHAT_STATS.SUCCESS]: (state, { payload: { payload } }) => ({ ...state, currentChatStats: payload }),
    [CHATS_FILTER_SET]: (state, { payload }) => ({ ...state, filter: payload })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/entities/ChatsStatsReducer.js